// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingsCountForSerpRequest,
  TGetNewbuildingsCountForSerpModel,
  IMappers,
  TGetNewbuildingsCountForSerpResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsCountForSerpResponse } from '../../entities/get_newbuildings_by_params/GetNewbuildingsCountForSerpResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsCountForSerpModel(
  parameters: TGetNewbuildingsCountForSerpRequest,
): TGetNewbuildingsCountForSerpModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-newbuildings-count-for-serp/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingsCountForSerpOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingsCountForSerpRequest;
}

export async function fetchGetNewbuildingsCountForSerp<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsCountForSerpOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsCountForSerpResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsCountForSerpModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingsCountForSerpResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsCountForSerpResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsCountForSerpResponse>;
}
